import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * VariantsProcessor формирует доступные и выбранный вариант, производит валидарцию выбранного
 */
export class VariantsProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param setUpServiceData
   * @param _
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    setUpServiceData: SetUpServiceData,
    _: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const selectedVariantId = setUpServiceData.Variant.id;

    let variants = [additionalServiceState.LastServiceInPath];
    if (additionalServiceState.LastServiceInPath.is_variants) {
      variants = [...additionalServiceState.LastServiceInPath.children];
    }

    const isValid = variants.map((v) => v.id).includes(selectedVariantId);

    return {
      isValid,
      additionalServiceState: {
        ...additionalServiceState,
        SelectedVariant: isValid ? selectedVariantId : '',
        Variants: isValid ? variants : [],
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
